import { RequireAuth } from 'hoc/RequireAuth'
import { ErrorBoundaryPage } from 'layouts/ErrorBoundaryPage'
import ErrorPerms from 'layouts/ErrorPerms'
import Layout from 'layouts/Layout'
import LoginPage from 'layouts/LoginPage'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { hasLicense, hasPermission } from 'utils'
import { routeConfig } from 'utils/routerConfig/routeConfig'

export function createAppRouter(permissions) {
	return createBrowserRouter([
		{
			path: '/',
			element: <Layout />,
			errorElement: <ErrorBoundaryPage />,
			children: [
				{ path: '/login', element: <LoginPage /> },
				{ index: true, element: <Navigate to='/feed' replace /> },
				...routeConfig.map(route => ({
					path: route.path,
					element: (
						<RequireAuth>
							{hasPermission(permissions, route.permissions) &&
							hasLicense(permissions, route.licenses) ? (
								<route.component />
							) : (
								<Navigate to={route.redirect} replace />
							)}
						</RequireAuth>
					),
				})),
				{ path: '*', element: <Navigate to='/feed' replace /> },
			],
		},
		{ path: '/error', element: <ErrorPerms /> },
	])
}
